<template>
<div>
	<div class="dg-backdrop"></div>
<div class="dg-container dialog-container">
    <div class="dg-content-cont dg-content-cont--floating">
        <div class="dg-main-content">
            <div class="dg-view-wrapper">
                <div class="dg-content-body">
                    <div class="dg-content">
                        <form autocomplete="off" class="dg-form">
                            <label class="cookie-label-af-cnom">{{ isEmpty(workerId) ? 'Add New' : 'Edit' }} Worker</label>
                            <input type="hidden" v-model="form.id" />
                            <input type="hidden" v-model="form.updatedBy" />
                            <div>
                                <label class="cookie-label-af-code">Code Name: </label>
                                <input type="text" @keypress="alphaNumericOnly" @keyup="customTrigger" v-model="form.name" :class="emptyOrConflictField(form.name, dialog.duplicateCodeName)" placeholder="Enter Code Name" autocomplete="off" class="form-control form-control-sm" />
                            </div>
                            <div>
                                <label class="cookie-label-af-code">Capacity: </label> 
                                <input type="number" @keypress="numberOnly" v-model="form.capacity" :class="emptyField(form.capacity, 0)" placeholder="Enter Capacity (number greater than 0)" autocomplete="off" class="form-control form-control-sm" />
                            </div>
                            <div>
                                <label class="cookie-label-af-code">Process: </label> 
                                <input type="number" @keypress="numberOnly" v-model="form.process" :class="emptyField(form.process, 0)" placeholder="Enter Process (number greater than 0)" autocomplete="off" class="form-control form-control-sm" />
                            </div>
                            <div>
                                <label class="cookie-label-af-code">Delay: </label> 
                                <input type="number" @keypress="numberOnly" v-model="form.delay" :class="emptyField(form.delay)" placeholder="Enter Delay (number)" autocomplete="off" class="form-control form-control-sm" />
                            </div>
                            <div class="worker-status-container">
                                <label class="cookie-label-af-code">Worker Status: </label> 
                                <select v-model="form.enabled" class="form-control form-control-sm">
                                    <option value="true">Enabled</option>
                                    <option value="false">Disabled</option>
                                </select>
                            </div>
                            <div class="error-message-container" v-if="dialog.duplicateCodeName">
                                <span class="error-message">Code name already exists</span>
                            </div>
                        </form>
                        </div>
                    </div>
                    <div class="dg-content-footer">
                        <button class="dg-btn dg-btn--cancel" :disabled="dialog.disableButtons" @click="close()">
                            <span>Cancel</span>
                        </button>
                        <button class="dg-btn dg-btn--ok dg-pull-right" :disabled="!validInputs || dialog.disableButtons" @click="submit()">
                            <span class="dg-btn-content">
                                <span>{{ isEmpty(workerId) ? 'Register' : 'Update' }}</span>
                            </span>
                        </button>
                        <div class="dg-clear"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<style scoped>
.error-message{
    color: red;
    font-size: 15px;
}
.error-message-container{
    text-align: center;
}
.worker-status-container{
    padding-bottom: 15px;
}
.dialog-container{
    top: 150px!important;
}
form > div > input, select {
    width: 100%;
    padding-left: 7px!important;
}
form > div > label {
    padding: 8px;
    padding-top: 15px;
}
form > div {
    text-align: left;
    line-height: 1em !important;
}
.dialog-custom{
    width: 100%;
    padding: 7px 15px;
    font-size: 16px;
    border-radius: 4px;
    border: 2px solid rgb(133 133 133);
}
.dg-content-body {
    border-bottom: 2px solid #E1E6EA;
    padding-bottom: 15px;
}
.dg-content-footer {
    position: relative;
    padding: 15px 0 0;
    text-align: left !important;
}
.empty-field{
    border: 2px solid #FF0000;
}
</style>

<script>
import Utils from '../../../js/helpers/Utils';
import { mapActions, mapGetters } from 'vuex';

export default {
    props: {
        workerId: {
            type: String,
            required: false
        },
        userEmail: {
            type: String,
            required: true
        },
        sessionId: {
            type: String,
            required: true
        }
    },
    data(){
        return {
            form: {
                id: '',
                name: '',
                capacity: '',
                process: '',
                delay: '',
                updatedBy: '',
                enabled: true,
            },
            dialog: {
                disableButtons: false,
                duplicateCodeName: false,
            }
        };
    },
    created(){
        let params = {
            userEmail: this.userEmail,
            sessionId: this.sessionId
        };
        this.isOperationEnabled(params).then(res => {
            if(!res.records){
                top.window.location.reload();
            }
        });

        if(this.workerId){
            let params = {
                userEmail: this.userEmail,
                sessionId: this.sessionId,
                id: this.workerId
            };
            this.retrieveWorker(params).then(() => {
                this.form.id = this.worker.id;
                this.form.name = this.worker.codeName;
                this.form.capacity = this.worker.capacity;
                this.form.process = this.worker.process;
                this.form.delay = this.worker.delay;
                this.form.enabled = this.worker.enabled;
                this.form.updatedBy = this.userEmail;
            });
        }
    },
    computed: {
        ...mapGetters({
            worker: 'worker/worker',
        }),
        validInputs: function(){
            let passed = true;
            passed = !passed ? passed : !Utils.isEmpty(this.form.name);
            passed = !passed ? passed : !Utils.isEmpty(this.form.capacity) && !isNaN(this.form.capacity) && this.form.capacity > 0;
            passed = !passed ? passed : !Utils.isEmpty(this.form.process) && !isNaN(this.form.process) && this.form.process > 0;
            passed = !passed ? passed : !Utils.isEmpty(this.form.delay);
            passed = !passed ? passed : !Utils.isEmpty(this.form.enabled);
            return passed;
        }
    },
    methods:{
        ...mapActions({
            addNewWorker: 'worker/addNewWorker',
            retrieveWorker: 'worker/retrieveWorker',
            updateWorker: 'worker/updateWorker',
            isOperationEnabled: 'worker/isOperationEnabled',
        }),
        close() {
            this.form.id = '';
            this.form.name = '';
            this.form.capacity = '';
            this.form.process = '';
            this.form.delay = '';
            this.form.enabled = '';
            this.form.updatedBy = '';
            this.$emit('close', true);
        },
        async submit(){
            this.dialog.disableButtons = true;
            let params = {
                userEmail: this.userEmail,
                sessionId: this.sessionId,
                id: this.form.id,
                codeName: this.form.name,
                capacity: this.form.capacity,
                process: this.form.process,
                delay: this.form.delay,
                enabled: this.form.enabled,
                updatedBy: this.userEmail,
            };

            let response = null;
            if(this.workerId){ await this.updateWorker(params).then(res => { response = res; }); }
            else{ await this.addNewWorker(params).then(res => { response = res; }); }

            if(response.status_code == "ERR9"){
                this.dialog.duplicateCodeName = true;
            } else {
                this.dialog.duplicateCodeName = false;
                this.$emit('submit', true);
            }
            this.dialog.disableButtons = false;
        },
        isEmpty(value){
            return Utils.isEmpty(value);
        },
        numberOnly(event){
            let suppressKey = [101, 43, 45, 46];
            let keyCode = (event.keyCode ? event.keyCode : event.which);
            if (suppressKey.some(key => key == keyCode)) { event.preventDefault(); }
        },
        alphaNumericOnly(event){
            if(!Utils.ALPHANUMERIC.test(event.key) && event.key != "-" && event.key != "_") {
                event.preventDefault();
            }
        },
        emptyField(value, greaterThan){
            let compareFilter = Utils.isEmpty(greaterThan) || isNaN(greaterThan) ? true : value > greaterThan;
            return Utils.isEmpty(value) || !compareFilter ? 'empty-field' : '';
        },
        emptyOrConflictField(value, duplicate){
            return Utils.isEmpty(value) || duplicate ? 'empty-field' : '';
        },
        customTrigger(){
            this.dialog.duplicateCodeName = false;
        }
    }
};
</script>
